import moment from "moment";
import strtotime from "locutus/php/datetime/strtotime";

export const quarters = (date: string) => {
    const ret: Array<{type: string, value: number, name: string, from: string, to: string, currentTime?: boolean}> = [];
    let currentQuarter: moment.Moment | number = moment();
    const current = moment(date, "YYYY-MM-DD HH:mm:ss");
    const currentYear = current.format("YYYY");
    const currentQuarterYear = currentQuarter.format("YYYY");
    currentQuarter = currentQuarter.quarter();
    [1,2,3,4].map((quarter) => {
        ret.push({type: "quarter", value: quarter, name: quarter + ". negyedév", from: moment(date, "YYYY-MM-DD HH:mm:ss").quarter(quarter).startOf('quarter').format("YYYY-MM-DD"), to: moment(date, "YYYY-MM-DD HH:mm:ss").quarter(quarter).endOf('quarter').format("YYYY-MM-DD")});
        if (currentYear === currentQuarterYear && currentQuarter === quarter) {
            ret.push({type: "quarter", currentTime: true, value: quarter, name: quarter + ". negyedév (Mai napig)", from: moment(date, "YYYY-MM-DD HH:mm:ss").quarter(quarter).startOf('quarter').format("YYYY-MM-DD"), to: moment().endOf('day').format("YYYY-MM-DD")});
        }
    });
    return ret;
}

export const halfyears = (date: string) => {
    const ret: Array<{type: string, value: number, name: string, from: string, to: string, currentTime?: boolean}> = [];
    let currentQuarter: moment.Moment | number = moment();
    const current = moment(date, "YYYY-MM-DD HH:mm:ss");
    const currentYear = current.format("YYYY");
    const currentQuarterYear = currentQuarter.format("YYYY");
    currentQuarter = currentQuarter.quarter();
    ret.push({type: "half", value: 1, name: "1. fél év", from: moment(date, "YYYY-MM-DD HH:mm:ss").quarter(1).startOf('quarter').format("YYYY-MM-DD"), to: moment(date, "YYYY-MM-DD HH:mm:ss").quarter(2).endOf('quarter').format("YYYY-MM-DD")});
    if (currentYear === currentQuarterYear && [1,2].indexOf(currentQuarter) !== -1) {
        ret.push({type: "half", currentTime: true, value: 1, name: "1. fél év (Mai napig)", from: moment(date, "YYYY-MM-DD HH:mm:ss").quarter(1).startOf('quarter').format("YYYY-MM-DD"), to: moment().endOf('day').format("YYYY-MM-DD")})
    }
    ret.push({type: "half", value: 2, name: "2. fél év", from: moment(date, "YYYY-MM-DD HH:mm:ss").quarter(3).startOf('quarter').format("YYYY-MM-DD"), to: moment(date, "YYYY-MM-DD HH:mm:ss").quarter(4).endOf('quarter').format("YYYY-MM-DD")});
    if (currentYear === currentQuarterYear && [3,4].indexOf(currentQuarter) !== -1) {
        ret.push({type: "half", currentTime: true, value: 2, name: "2. fél év (Mai napig)", from: moment(date, "YYYY-MM-DD HH:mm:ss").quarter(3).startOf('quarter').format("YYYY-MM-DD"), to: moment().endOf('day').format("YYYY-MM-DD")})
    }
    return ret;
}

export const months = (date: string) => {
    const ret: Array<{type: string, value: number, name: string, from: string, to: string, currentTime?: boolean}> = [];
    let currentMonth: moment.Moment | number = moment();
    const current = moment(date, "YYYY-MM-DD HH:mm:ss");
    const currentYear = current.format("YYYY");
    const currentMonthYear = currentMonth.format("YYYY");
    currentMonth = currentMonth.month();

    [0,1,2,3,4,5,6,7,8,9,10,11].map((month) => {
        ret.push({type: "month", value: month, name: moment(date, "YYYY-MM-DD HH:mm:ss").month(month).format("MMMM"), from: moment(date, "YYYY-MM-DD HH:mm:ss").month(month).startOf("month").format("YYYY-MM-DD"), to: moment(date, "YYYY-MM-DD HH:mm:ss").month(month).endOf("month").format("YYYY-MM-DD")});
        if (currentYear === currentMonthYear && month === currentMonth) {
            ret.push({type: "month", currentTime: true, value: month, name: moment(date, "YYYY-MM-DD HH:mm:ss").month(month).format("MMMM") + " (Mai napig)", from: moment(date, "YYYY-MM-DD HH:mm:ss").month(month).startOf("month").format("YYYY-MM-DD"), to: moment().endOf("day").format("YYYY-MM-DD")});
        }
    });
    return ret;
}

export const fullyear = (date: string) => {
    const ret: Array<{type: string, value: number, name: string, from: string, to: string, currentTime?: boolean}> = [{type: "year", value: Number(moment(date, "YYYY-MM-DD HH:mm:ss").format("YYYY")), name: "teljes év", from: moment(date, "YYYY-MM-DD HH:mm:ss").quarter(1).startOf('quarter').format("YYYY-MM-DD"), to: moment(date, "YYYY-MM-DD HH:mm:ss").quarter(4).endOf('quarter').format("YYYY-MM-DD")}];
    if (moment().format("YYYY") === moment(date, "YYYY-MM-DD HH:mm:ss").format("YYYY")) {
        ret.push({type: "year", currentTime: true, value: Number(moment(date, "YYYY-MM-DD HH:mm:ss").format("YYYY")), name: "teljes év (Mai napig)", from: moment(date, "YYYY-MM-DD HH:mm:ss").quarter(1).startOf('quarter').format("YYYY-MM-DD"), to: moment().format("YYYY-MM-DD")});
    }
    return ret;
}

export const ifCompletedInput = (event: {which: number, preventDefault: () => void}) => {
    if ([27].indexOf(event.which) !== -1) {
        event.preventDefault();
        return false;
    }
    if ([13, 9, 38, 40].indexOf(event.which) !== -1) {
        event.preventDefault();
        return true;
    }
    return false;
}

// https://gist.github.com/ralphcrisostomo/3141412
export const compressArray = <T extends any[]>(original: T): Array<{value: T[number], count: number}> => {

    const compressed = [];
    // make a copy of the input array
    let copy = original.slice(0);

    // first loop goes over every element
    let i = 0;
    for (; i < original.length; i++) {

        let myCount = 0;
        // loop over every element in the copy and see if it's the same
        let w = 0;
        for (; w < copy.length; w++) {
            if (original[i] + "" === "" + copy[w]) {
                // increase amount of times duplicate is found
                myCount++;
                // sets item to undefined
                delete copy[w];
            }
        }

        if (myCount > 0) {
            compressed.push({value: original[i], count: myCount});
        }
    }

    return compressed;
};

export const calcClassName = ({current, amount, total}: {current: number, amount: number, total: number}) => {
    const counts = compressArray([current, amount, total]);
    const ret: {current?: number, amount?: number, total?: number} = {};
    for (let i = 0; i < counts.length; i++) {
        if (counts[i].value + "" === "" + current) {
            ret.current = counts[i].count;
        }
        if (counts[i].value + "" === "" + amount) {
            ret.amount = counts[i].count;
        }
        if (counts[i].value + "" === "" + total) {
            ret.total = counts[i].count;
        }
    }
    return ret;
}


// https://github.com/sumia01/js-forint-kerekites
export function hufRound(x: number) {
    if (x > 0) {
        return (x % 5) >= 2.5 ? parseInt(String(x / 5)) * 5 + 5 : parseInt(String(x / 5)) * 5;
    } else {
        return ((Math.abs(x) % 5) >= 2.5 ? parseInt(String(Math.abs(x) / 5)) * 5 + 5 : parseInt(String(Math.abs(x) / 5)) * 5)*-1;
    }
};

// https://gist.github.com/wesleybliss/432f9a63015736b99ee5751646e3e956
export const stringify = (someObject: any) => {
    let cache: any[] = [];
    const o = JSON.stringify(someObject, (key, value) => {
        if (typeof value === 'object' && value !== null) {
            if (cache.indexOf(value) !== -1) {
                // Circular reference found, discard key
                return
            }
            // Store value in our collection
            cache.push(value)
        }
        return value
    });
    cache = null; // GC
    return o
};

export const isTrue = (value: any) => {
    return value === 1 || value === "1" || value === true || value === "true" || (Array.isArray(value) ? value.length > 0 : false) || (value instanceof Object ? Object.keys(value).length > 0 : false) || (isNaN(value) === false && value > 0);
}

export const isFalse = (value: any) => {
    return value === '' || value === undefined || value === 0 || value === "0" || value === false || value === "false" || (Array.isArray(value) ? value.length === 0 : false) || (value instanceof Object ? Object.keys(value).length === 0 : (value === null));
}

export const isEmpty = (value: any) => {
    return isFalse(value);
}

export const noop = () => {};

export const delay = (n: number) => new Promise(resolve => setTimeout(resolve, n));

export const cancellablePromise = <T extends Promise<any>>(promise: T): T & { cancel: () => void } => {
    let isCanceled = false;

    const wrappedPromise: T & { cancel: () => void } = new Promise((resolve, reject) => {
        promise.then(
            value => (isCanceled ? reject({ isCanceled, value }) : resolve(value)),
            error => reject({ isCanceled, error }),
        );
    }) as any;

    wrappedPromise.cancel = () => (isCanceled = true);

    return wrappedPromise;
};

export const mergeFieldProps = function () {
    let props: { [key: string]: any } = {};
    const args = [].slice.call(arguments);
    args.map((arg: any) => {
        arg.disabled = props.disabled || arg.disabled;
        if (arg) {
            props = {...props, ...arg};
        }
    })
    return props;
}

export const isChristmas = (week = false) => {
    let date = new Date();
    let month = date.getMonth();
    let day = date.getDate();
    if (week && month === 11 && day > 20 && day < 30) return true;
    if (month === 11 && day === 25) return true; // Eleven because computers start counting @ 0
    return false;
}

export const stringToDate = (value: string) => {
    if (value) {
        value = value.toLowerCase().trim();
        if ((value.indexOf("+") === 0 || value.indexOf("-") === 0) && new RegExp(["nap", "hónap", "év"].join("|")).test(value)) {
            let type = 'days';
            switch (value.replace(/[\-0-9]/g, '').trim()) {
                case "nap":
                    type = "days";
                    break;
                case "hónap":
                    type = "months";
                    break;
                case "év":
                    type = "years";
                    break;
            }
            return moment().add(value.replace(/[^\-0-9]/g, ''), type as any).toDate();
        } else if (value === "holnap") {
            return moment().add(1, 'days').toDate();
        } else if (value === "ma") {
            return moment().toDate();
        } else if (value === "tegnap") {
            return moment().add(-1, 'days').toDate();
        } else {
            value = strtotime(value);
            if (value) {
                return new Date((value as unknown as number) * 1000);
            }
            //return moment(value, "YYYY-MM-DD HH:mm:ss").toDate();
        }
    }
    return null;
}

export const operation = (property: any, value: any, operator: string) => {
    operator = operator || "~";
    switch (operator) {
        case "!~":
            return property + "" !== "" + value;
        case "~":
            return property + "" === "" + value;
        case "!=":
            return property != value;
        case "==":
            return property == value;
        case "<":
            return property < value;
        case ">":
            return property > value;
        case "<=":
            return property <= value;
        case ">=":
            return property >= value;
        case "===":
            return property === value;
        case "not in":
            return property.indexOf(value) === -1;
        case "in":
            return property.indexOf(value) !== -1;
        case "includes":
            return !!property.find((prop: any) => {
                return value + "" === "" + prop;
            });
        case "not includes":
            return !property.find((prop: any) => {
                return value + "" === "" + prop;
            });
    }
}

export const is_scalar = (mixedVar: any) => {
    return !(Array.isArray(mixedVar) || Object.prototype.toString.call(mixedVar) === '[object Object]');
}


// https://stackoverflow.com/a/30810322
function copyTextToClipboard(text: string | number) {
    var textArea = document.createElement("textarea");

    //
    // *** This styling is an extra step which is likely not required. ***
    //
    // Why is it here? To ensure:
    // 1. the element is able to have focus and selection.
    // 2. if the element was to flash render it has minimal visual impact.
    // 3. less flakyness with selection and copying which **might** occur if
    //    the textarea element is not visible.
    //
    // The likelihood is the element won't even render, not even a
    // flash, so some of these are just precautions. However in
    // Internet Explorer the element is visible whilst the popup
    // box asking the user for permission for the web page to
    // copy to the clipboard.
    //

    // Place in the top-left corner of screen regardless of scroll position.
    textArea.style.position = 'fixed';
    textArea.style.top = '0';
    textArea.style.left = '0';

    // Ensure it has a small width and height. Setting to 1px / 1em
    // doesn't work as this gives a negative w/h on some browsers.
    textArea.style.width = '2em';
    textArea.style.height = '2em';

    // We don't need padding, reducing the size if it does flash render.
    textArea.style.padding = '0';

    // Clean up any borders.
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';

    // Avoid flash of the white box if rendered for any reason.
    textArea.style.background = 'transparent';


    textArea.value = String(text);

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        const successful = document.execCommand('copy');
        if (!successful) {
            throw {msg: 'Copying text command was unsuccessful'};
        }
        //var msg = successful ? 'successful' : 'unsuccessful';
        //console.log('Copying text command was ' + msg);
    } catch (err) {
        console.error(err);
        //console.log('Oops, unable to copy');
    }

    document.body.removeChild(textArea);
}

export const copy = (text: string | number) => {
    return copyTextToClipboard(text);
}

// https://www.geeksforgeeks.org/how-to-get-the-javascript-function-parameter-names-values-dynamically/
// JavaScript program to get the function
// name/values dynamically
function getParams(func: Function) {

    // String representaation of the function code
    let str = func.toString();

    // Remove comments of the form /* ... */
    // Removing comments of the form //
    // Remove body of the function { ... }
    // removing '=>' if func is arrow function
    str = str.replace(/\/\*[\s\S]*?\*\//g, '')
        .replace(/\/\/(.)*/g, '')
        .replace(/{[\s\S]*}/, '')
        .replace(/=>/g, '')
        .trim();

    // Start parameter names after first '('
    let start = str.indexOf("(") + 1;

    // End parameter names is just before last ')'
    let end = str.length - 1;

    const result = str.substring(start, end).split(", ");

    const params: string[] = [];

    result.forEach(element => {

        // Removing any default value
        element = element.replace(/=[\s\S]*/g, '').trim();

        if(element.length > 0)
            params.push(element);
    });

    return params;
}


// My function that parses a string into an XML DOM, throwing an Error if XML parsing fails
const parseXml = (xmlString: string) => {
    const parser = new DOMParser();
    // attempt to parse the passed-in xml
    const dom = parser.parseFromString(xmlString, 'text/xml');
    const error = isParseError(dom);
    if (error) {
        throw new Error(error);
    }
    return dom;
}

const isParseError = (parsedDocument: Document) => {
    // parser and parsererrorNS could be cached on startup for efficiency
    const parser = new DOMParser(),
        errorneousParse = parser.parseFromString('<', 'text/xml'),
        parsererrorNS = errorneousParse.getElementsByTagName("parsererror")[0].namespaceURI;

    if (parsererrorNS === 'http://www.w3.org/1999/xhtml') {
        // In PhantomJS the parseerror element doesn't seem to have a special namespace, so we are just guessing here :(
        if (parsedDocument.getElementsByTagName("parsererror").length > 0) {
            return parsedDocument.getElementsByTagName("parsererror")[0].textContent;
        }
        return false;
    }

    if (parsedDocument.getElementsByTagNameNS(parsererrorNS, "parsererror").length > 0) {
        return parsedDocument.getElementsByTagNameNS(parsererrorNS, "parsererror")[0].textContent;
    }
    return false;
};

export function hashCode(str: string) {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
}

export function intToRGB(i: number){
    var c = (i & 0x00FFFFFF)
        .toString(16)
        .toUpperCase();

    return "00000".substring(0, 6 - c.length) + c;
}

export function hexToRgb(hex: string) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : {r: 255, g: 255, b: 255};
}

export function formatNiceUrl(txt: string){
   return txt
       .trim()
       .normalize("NFD")
       .replace(/[\u0300-\u036f]/g,'')
       .toLowerCase()
       .replace(/ /g, '-')
       .replace(/[^\w-]+/g, '')
       .replace(/&#?[a-z0-9_,]+;/ig, '')
       .replace(/-{2,}/g, '-')
       .replace(/^[-]+/, '')
       .replace(/[-]+$/, '');
}